module.exports = __webpack_public_path__ + "img/jovem-pan-campinas.8595642c.png";